import React from 'react';

const LearnBody = () => {
    return (
        <section>
            <article>
                <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
                    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-5">
                        <div className="grid gap-6 md:grid-cols-2 md:col-span-2 lg:col-span-3">
                            <div className="rounded lg:p-5 lg:transition lg:duration-300 lg:hover:bg-indigo-50">
                                <div className="flex items-center mb-1">
                                    <span className="flex items-center justify-center w-4 h-4 mr-2 text-xs font-medium text-white rounded bg-secondary-focus">
                                        1
                                    </span>
                                    <p className="text-lg font-semibold sm:text-base">
                                        Read the recipe
                                    </p>
                                </div>
                                <p className="text-sm text-gray-900">
                                    Take a good look at the recipe. Don’t just skim it; read it
                                    through from start to finish. As you read, visualize doing the
                                    steps which will help when you’re prepping.
                                </p>
                            </div>
                            <div className="rounded lg:p-5 lg:transition lg:duration-300 lg:hover:bg-teal-50">
                                <div className="flex items-center mb-1">
                                    <span className="flex items-center justify-center w-4 h-4 mr-2 text-xs font-medium text-white rounded bg-secondary-focus">
                                        2
                                    </span>
                                    <p className="text-lg font-semibold sm:text-base">
                                        Know the assumptions
                                    </p>
                                </div>
                                <p className="text-sm text-gray-900">
                                    All recipes are written using certain conventions, which define
                                    the characteristics of common ingredients. The rules vary from
                                    place to place.
                                </p>
                            </div>
                            <div className="rounded lg:p-5 lg:transition lg:duration-300 lg:hover:bg-teal-50">
                                <div className="flex items-center mb-1">
                                    <span className="flex items-center justify-center w-4 h-4 mr-2 text-xs font-medium text-white rounded bg-secondary-focus">
                                        3
                                    </span>
                                    <p className="text-lg font-semibold sm:text-base">
                                        Figure out the timing
                                    </p>
                                </div>
                                <p className="text-sm text-gray-900">
                                    Check the “prep time” and “total time” listed at the top to be
                                    sure you have enough time to complete the recipe. Look for hints,
                                    such as the words “meanwhile” .
                                </p>
                            </div>
                            <div className="rounded lg:p-5 lg:transition lg:duration-300 lg:hover:bg-indigo-50">
                                <div className="flex items-center mb-1">
                                    <span className="flex items-center justify-center w-4 h-4 mr-2 text-xs font-medium text-white rounded bg-secondary-focus">
                                        4
                                    </span>
                                    <p className="text-lg font-semibold sm:text-base">Plan ahead</p>
                                </div>
                                <p className="text-sm text-gray-900">
                                    Missing a prep instruction can leave you scrambling in the middle
                                    of a recipe. Keep your eyes peeled for time-consuming steps and be
                                    careful.
                                </p>
                            </div>
                        </div>
                        <div className="relative md:col-span-2 lg:col-span-2">
                            <img
                                className="inset-0 object-cover object-bottom w-full h-56 rounded shadow-lg lg:absolute lg:h-full"
                                src="https://i.ibb.co/WH7qq4s/learn.jpg"
                                alt="learn"
                            />
                        </div>
                    </div>
                </div>
            </article>
            <article>
                <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
                    <div className="max-w-xl mb-10 md:mx-auto sm:text-center lg:max-w-2xl md:mb-12">
                        <div>
                            <p className="inline-block px-3 py-px mb-4 text-xs font-semibold tracking-wider text-teal-900 uppercase rounded-full bg-teal-accent-400">
                                Steps of learning
                            </p>
                        </div>
                        <h2 className="max-w-lg mb-6 font-sans text-3xl font-bold leading-none tracking-tight text-gray-900 sm:text-4xl md:mx-auto">
                            <span className="relative inline-block">
                                <svg
                                    viewBox="0 0 52 24"
                                    fill="currentColor"
                                    className="absolute top-0 left-0 z-0 hidden w-32 -mt-8 -ml-20 text-blue-gray-100 lg:w-32 lg:-ml-28 lg:-mt-10 sm:block"
                                >
                                    <defs>
                                        <pattern
                                            id="18302e52-9e2a-4c8e-9550-0cbb21b38e55"
                                            x="0"
                                            y="0"
                                            width=".135"
                                            height=".30"
                                        >
                                            <circle cx="1" cy="1" r=".7" />
                                        </pattern>
                                    </defs>
                                    <rect
                                        fill="url(#18302e52-9e2a-4c8e-9550-0cbb21b38e55)"
                                        width="52"
                                        height="24"
                                    />
                                </svg>
                                <span className="relative">Get</span>
                            </span>{' '}
                            the steps of learning form an amazing guideline!
                        </h2>
                        <p className="text-base text-gray-700 md:text-lg">
                            Steps by step learning is the best way to learn anything. To learn anything step by step guideline is easy to follow.
                        </p>
                    </div>
                    <div className="grid gap-6 row-gap-10 lg:grid-cols-2">
                        <div className="relative">
                            <img
                                className="inset-0 object-cover object-bottom w-full rounded shadow-lg h-96 lg:absolute lg:h-full"
                                src="https://i.ibb.co/NKxzgh9/learn2.jpg"
                                alt="learn"
                            />
                        </div>

                        <div className="lg:py-6 lg:pr-16">
                            <div className="flex">
                                <div className="flex flex-col items-center mr-4">
                                    <div>
                                        <div className="flex items-center justify-center w-10 h-10 border rounded-full">
                                            <svg
                                                className="w-4 text-gray-600"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                viewBox="0 0 24 24"
                                            >
                                                <line
                                                    fill="none"
                                                    strokeMiterlimit="10"
                                                    x1="12"
                                                    y1="2"
                                                    x2="12"
                                                    y2="22"
                                                />
                                                <polyline
                                                    fill="none"
                                                    strokeMiterlimit="10"
                                                    points="19,15 12,22 5,15"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="w-px h-full bg-gray-300" />
                                </div>
                                <div className="pt-1 pb-8">
                                    <p className="mb-2 text-lg font-bold">Step 1</p>
                                    <p className="text-gray-700">
                                        All recipes are written using certain conventions, which define
                                        the characteristics of common ingredients. The rules vary from
                                        place to place.
                                    </p>
                                </div>
                            </div>
                            <div className="flex">
                                <div className="flex flex-col items-center mr-4">
                                    <div>
                                        <div className="flex items-center justify-center w-10 h-10 border rounded-full">
                                            <svg
                                                className="w-4 text-gray-600"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                viewBox="0 0 24 24"
                                            >
                                                <line
                                                    fill="none"
                                                    strokeMiterlimit="10"
                                                    x1="12"
                                                    y1="2"
                                                    x2="12"
                                                    y2="22"
                                                />
                                                <polyline
                                                    fill="none"
                                                    strokeMiterlimit="10"
                                                    points="19,15 12,22 5,15"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="w-px h-full bg-gray-300" />
                                </div>
                                <div className="pt-1 pb-8">
                                    <p className="mb-2 text-lg font-bold">Step 2</p>
                                    <p className="text-gray-700">
                                        The first mate and his Skipper too will do their very best to
                                        make the others comfortable in their tropic island nest. Michael
                                        Knight a young loner.
                                    </p>
                                </div>
                            </div>
                            <div className="flex">
                                <div className="flex flex-col items-center mr-4">
                                    <div>
                                        <div className="flex items-center justify-center w-10 h-10 border rounded-full">
                                            <svg
                                                className="w-4 text-gray-600"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                viewBox="0 0 24 24"
                                            >
                                                <line
                                                    fill="none"
                                                    strokeMiterlimit="10"
                                                    x1="12"
                                                    y1="2"
                                                    x2="12"
                                                    y2="22"
                                                />
                                                <polyline
                                                    fill="none"
                                                    strokeMiterlimit="10"
                                                    points="19,15 12,22 5,15"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="w-px h-full bg-gray-300" />
                                </div>
                                <div className="pt-1 pb-8">
                                    <p className="mb-2 text-lg font-bold">Step 3</p>
                                    <p className="text-gray-700">
                                        Tell them I hate them. Is the Space Pope reptilian!? Tell her
                                        she looks thin. Hello, little man. I will destroy you!
                                    </p>
                                </div>
                            </div>
                            <div className="flex">
                                <div className="flex flex-col items-center mr-4">
                                    <div>
                                        <div className="flex items-center justify-center w-10 h-10 border rounded-full">
                                            <svg
                                                className="w-4 text-gray-600"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                viewBox="0 0 24 24"
                                            >
                                                <line
                                                    fill="none"
                                                    strokeMiterlimit="10"
                                                    x1="12"
                                                    y1="2"
                                                    x2="12"
                                                    y2="22"
                                                />
                                                <polyline
                                                    fill="none"
                                                    strokeMiterlimit="10"
                                                    points="19,15 12,22 5,15"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="w-px h-full bg-gray-300" />
                                </div>
                                <div className="pt-1 pb-8">
                                    <p className="mb-2 text-lg font-bold">Step 4</p>
                                    <p className="text-gray-700">
                                        If one examines precultural libertarianism, one is faced with a
                                        choice: either accept rationalism or conclude that context is a
                                        product.
                                    </p>
                                </div>
                            </div>
                            <div className="flex">
                                <div className="flex flex-col items-center mr-4">
                                    <div>
                                        <div className="flex items-center justify-center w-10 h-10 border rounded-full">
                                            <svg
                                                className="w-6 text-gray-600"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <polyline
                                                    fill="none"
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeMiterlimit="10"
                                                    points="6,12 10,16 18,8"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                                <div className="pt-1">
                                    <p className="mb-2 text-lg font-bold">Success</p>
                                    <p className="text-gray-700" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </section>
    );
};

export default LearnBody;